export enum FieldContainer {
  Product,
  Cos,
  Header,
  EmailRfq
}
